require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./recipes-tava-pulao.json") })
        }
      }, "path---recipes-tava-pulao");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---recipes-tava-pulao!./.cache/json/recipes-tava-pulao.json
// module id = 741
// module chunks = 231608221292675